import { render, staticRenderFns } from "./CampaignFieldsCardRowDate.vue?vue&type=template&id=55da16ee"
import script from "./CampaignFieldsCardRowDate.vue?vue&type=script&lang=js"
export * from "./CampaignFieldsCardRowDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports